export interface SurveyFormContainerType {
  children: React.ReactNode;
  className?: string;
}
export function SurveyFormContainer({ children, className = "" }) {
  return (
    <div className={`bg-white rounded border border-light ${className}`}>
      {children}
    </div>
  );
}
